import React from 'react';

import {
	useIsBelowSmallOnly,
	useIsSmallAndAbove,
} from '../../../hooks/mediaQueries';
import DesktopDynamicBanner from './DesktopDynamicBanner';
import MobileDynamicBanner from './MobileDynamicBanner';

export const DynamicBanner = (props) => {
	const {
		Title,
		SubtitleOne: Description,
		SubtitleTwo: TextLink,
		ImageLinkUrl,
		TextLinkUrl,
		LinkUrl,
		OpenTextLinkInNewWindow,
		OpenInNewWindow,
	} = props;

	const isBelowSmallOnly = useIsBelowSmallOnly();
	const isSmallAndAbove = useIsSmallAndAbove();

	if (!Title || !Description || !TextLink) {
		return null;
	}

	// Link can be provided via either of these depending on configuration
	const linkUrl = TextLinkUrl || ImageLinkUrl || LinkUrl;

	const openTextLinkInNewTab = (e) => {
		if (OpenTextLinkInNewWindow || OpenInNewWindow) {
			e.preventDefault();
			window.open(linkUrl);
		}
	};

	return (
		<React.Fragment>
			{isBelowSmallOnly && (
				<MobileDynamicBanner
					{...props}
					linkUrl={linkUrl}
					openTextLinkInNewTab={openTextLinkInNewTab}
				/>
			)}
			{isSmallAndAbove && (
				<DesktopDynamicBanner
					{...props}
					linkUrl={linkUrl}
					openTextLinkInNewTab={openTextLinkInNewTab}
				/>
			)}
		</React.Fragment>
	);
};

export default DynamicBanner;
